import React from 'react';
import s from './Button.module.scss';
import classNames from "classnames";

interface IButton {
    text: string
    withBorder?: boolean
    isWhite?: boolean
    isBig?: boolean
    isGradient?: boolean
    className?: string
    onClick?: any
    disabled?: boolean
    id?: string
}
const Button = ({text, withBorder, isBig, isWhite, isGradient, className, onClick, disabled, id}: IButton) => {
    return (
        <button className={classNames(s.button, withBorder && s['button_border'], isBig && s['button_big'], isWhite && s['button_white'], isGradient && s['button_gradient'], className)} onClick={onClick} disabled={disabled} id={id}>
            <span>{text}</span>
        </button>
    );
};

export default Button;